import { InboxArrowUpIcon } from './InboxArrowUpIcon';

/**
 * author: Austin Andrews
 * id 5317ED5A-9D37-4C50-AA7D-83491547D214
 * name inbox-arrow-up
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/inbox-arrow-up.svg
 * tags
 */
export const MoveFromInboxIcon = InboxArrowUpIcon;
export default MoveFromInboxIcon